import React from 'react';

/**
 * Global ErrorBoundary - łapie niezłapane błędy React i wyświetla fallback UI
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'sans-serif' }}>
          <h2 style={{ color: 'var(--danger)' }}>Wystąpił nieoczekiwany błąd</h2>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '20px' }}>
            {this.state.error?.message || 'Coś poszło nie tak.'}
          </p>
          <button
            onClick={() => { this.setState({ hasError: false, error: null }); window.location.href = '/'; }}
            style={{ padding: '10px 24px', border: '1px solid var(--info)', color: 'var(--info)' , borderRadius: '6px', cursor: 'pointer', fontSize: '14px' }}
          >
            Wróć do strony głównej
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

/**
 * RouteErrorBoundary — lżejsza wersja dla poszczególnych stron.
 * Crash jednej strony nie powoduje crashu całej aplikacji.
 * Pozwala na "Spróbuj ponownie" bez przeładowania.
 */
class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('RouteErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'sans-serif' }}>
          <h2 style={{ color: 'var(--danger)', fontSize: '18px' }}>Błąd na tej stronie</h2>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '20px', fontSize: '14px' }}>
            {this.state.error?.message || 'Coś poszło nie tak.'}
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              style={{ padding: '8px 20px', border: '1px solid var(--info)', color: 'var(--info)' , borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}
            >
              Spróbuj ponownie
            </button>
            <button
              onClick={() => window.location.href = '/'}
              style={{ padding: '8px 20px', border: '1px solid var(--text-muted)', color: 'var(--text-muted)' , borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}
            >
              Strona główna
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export { RouteErrorBoundary };
export default ErrorBoundary;
